import * as tslib_1 from "tslib";
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import addFavoritePersonaV1 from './v1/people/addFavoritePersonaV1';
import { lazyAddFavoritePersonaV2 } from 'owa-favorites';
export default function addFavoritePersona(personaId, emailAddress, displayName, actionSource) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var addFavoritePersonaV2, favoriteDisplayName;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isControlFeatureEnabled('tri-favorites-roaming')) return [3 /*break*/, 2];
                    return [4 /*yield*/, lazyAddFavoritePersonaV2.import()];
                case 1:
                    addFavoritePersonaV2 = _a.sent();
                    favoriteDisplayName = displayName || emailAddress;
                    addFavoritePersonaV2(emailAddress, favoriteDisplayName, actionSource);
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, addFavoritePersonaV1(personaId, emailAddress, displayName, actionSource)];
                case 3: return [2 /*return*/, _a.sent()];
                case 4: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=addFavoritePersona.js.map